module.exports = __webpack_public_path__ + "img/portfolio_3.c06a9134.jpg";